import React, {Component} from 'react';
import EpicMenu from '../Menus/EpicMenu';
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import Registro from './Registro';
import NuevaRegistro from './RegistrarH';
import { Button, Modal } from 'semantic-ui-react';

class PHumedad extends Component{
	constructor(props){
		super(props);
		this.newRegistro = this.newRegistro.bind(this);
		this.cambiarEstado = this.cambiarEstado.bind(this);
		this.app= firebase;
		this.database = this.app.firestore().collection('Humedad');
		this.state = {
			actividades: [],
			useModal: false,
		}
	}

	componentDidMount(){
		this.database.onSnapshot(querySnapshot =>{
			this.setState({actividades:[]})
			querySnapshot.forEach(doc=>{
				const previousAct = this.state.actividades;
				previousAct.push({
				id: doc.id,
				fecha: doc.data().fecha,//.toDate().toLocaleDateString(),
				variedad: doc.data().variedad,
				sector: doc.data().sector,
				estado: doc.data().estado,
				tuneles: doc.data().tuneles,
				})
				this.setState({
					actividades: previousAct
				})
			})
		
		})
	}

	cambiarEstado(id, estado){
		if (estado === 'Activa'){
			this.database.child(id).update({ estado: "Inactiva", });
		}
		else {
			this.database.child(id).update({ estado: "Activa", });
		};
	}

	newRegistro(actividad){
		this.database.add({
			fecha: actividad.fecha,
			sector: actividad.sector,
			tuneles: actividad.tuneles,
		})
		.then(()=>{
			//alert(':)')
		})
		.catch(e=>{
			alert(e)
		})
	}
	modalAgregar = () => (
		<Modal 
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<Button>Nuevo Registro</Button>}>
			<Modal.Header>Registrar Humedad</Modal.Header>
			<Modal.Content>
				<NuevaRegistro newRegistro={this.newRegistro} changeModal={this.changeUsModal} />
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
	render(){
		return (
		<div>
			<header className="App-header">
				<EpicMenu />
			</header>
			<h2>Registro de Humedad</h2>
			<div className="table-buttons" >
				<this.modalAgregar />
			</div>
			<div>
				<div  className="tabla">
				<table><tbody>
				<tr>
                    <th>Fecha</th>
					<th>Sector</th>
					<th>Tunel</th>
					<th>Cama</th>
                    <th>H Principio</th>
                    <th>H Mitad</th>
                    <th>H Final</th>
				</tr>
				{
					this.state.actividades.sort(({ sector: previousID }, { sector: currentID }) => previousID - currentID)
					.map((actividad) => {
						return (
							<tr key={actividad.id}><Registro  
								fecha={actividad.fecha}
								variedad={actividad.variedad}
								sector={actividad.sector}
								tuneles={actividad.tuneles}
								estado={actividad.estado}
								actID={actividad.id} 
								key={actividad.id} 
								cambiarEstado ={this.cambiarEstado}
							/></tr>
						)
					})
				}
				</tbody></table>
				</div>
			</div>
			<div>
				
			</div>
		</div>
		);
	}
}

export default PHumedad;




